module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_1.0b0ea87d.png";